/* globals rscpCfg, Control, IntegrationImplementation */

/* eslint-disable new-cap, camelcase */
function ScoLoader (intermediatePage, popupLauncherPage, pathToCourse, scoLaunchType, wrapScoWindowWithApi, standard) {
    this.IntermediatePage = intermediatePage;
    this.PopupLauncherPage = popupLauncherPage;
    this.PathToCourse = pathToCourse;
    this.ScoLaunchType = scoLaunchType;
    this.WrapScoWindowWithApi = wrapScoWindowWithApi;
    this.Standard = standard;
    this.ScoLoaded = false;

    // eslint-disable-next-line no-use-before-define
    this.ContentFrame = ScoLoader_FindContentFrame(window);

    if (this.ContentFrame === null) {
        Debug.AssertError("Unable to locate the content frame-" + IntegrationImplementation.CONTENT_FRAME_NAME);
    }
}

/* eslint-disable no-use-before-define */
ScoLoader.prototype.LoadSco = ScoLoader_LoadSco;
ScoLoader.prototype.UnloadSco = ScoLoader_UnloadSco;
ScoLoader.prototype.WriteHistoryLog = ScoLoader_WriteHistoryLog;
ScoLoader.prototype.WriteHistoryReturnValue = ScoLoader_WriteHistoryReturnValue;
ScoLoader.prototype.ConstructPreviewAiccSid = ScoLoader_ConstructPreviewAiccSid;
/* eslint-enable no-use-before-define */

function ScoLoader_WriteHistoryLog (str, atts) {
    HistoryLog.WriteEventDetailed(str, atts);
}

function ScoLoader_WriteHistoryReturnValue (str, atts) {
    HistoryLog.WriteEventDetailedReturnValue(str, atts);
}

// eslint-disable-next-line complexity
function ScoLoader_LoadSco (activity) {
    /* globals
       LAUNCH_TYPE_FRAMESET,
       LAUNCH_TYPE_POPUP,
       LAUNCH_TYPE_POPUP_WITHOUT_BROWSER_TOOLBAR,
       LAUNCH_TYPE_POPUP_WITH_MENU,
       LAUNCH_TYPE_POPUP_AFTER_CLICK,
       LAUNCH_TYPE_POPUP_AFTER_CLICK_WITHOUT_BROWSER_TOOLBAR,
       MergeQueryStringParameters,
       ConvertDateToIso8601String,
       HistoryLog
    */
    var historyAtts = {ev: "LoadSco"},
        pathToSco = "",
        scoLaunchType = this.ScoLaunchType,
        auLaunchMethod,
        cmi5Aus,
        aiccParams = "",
        isPreview,
        aiccSid,
        isSessionIdIsAGuid,
        activityLaunchPath,
        launchPath,
        showToolbar,
        showMenubar,
        launchAfterClick;

    if (activity) {
        historyAtts.ai = activity.ItemIdentifier;
        historyAtts.at = activity.LearningObject.Title;
    }

    this.WriteHistoryLog("", historyAtts);

    activity.LaunchedThisSession = false;

    if (activity.GetActivityStartTimestampUtc() === null) {
        activity.SetActivityStartTimestampUtc(ConvertDateToIso8601String(new Date()));
    }

    if (activity.GetAttemptStartTimestampUtc() === null) {
        activity.SetAttemptStartTimestampUtc(ConvertDateToIso8601String(new Date()));
    }

    if (this.Standard.isCmi5()) {
        pathToSco = rscpCfg.get("cmi5LaunchTemplate") + "&auId=" + encodeURIComponent(activity.ItemIdentifier);
        pathToSco += "&returnURL= " + encodeURIComponent(MergeQueryStringParameters(this.IntermediatePage.PageHref, this.IntermediatePage.Parameters));

        auLaunchMethod = "OwnWindow";
        cmi5Aus = rscpCfg.get("cmi5Aus");
        if (cmi5Aus[activity.ItemIdentifier]) {
            auLaunchMethod = cmi5Aus[activity.ItemIdentifier].launchMethod;
        }

        //
        // if they AU requires its own window then make sure that if we would normally
        // launch the AU in the frameset that we adjust it to be popup instead, ideally
        // we'd add a package property that allows it to takeover the player window and
        // then set the return URL to be the deliver page (aka window.location.href) so
        // the AU would bring the user back to the player at the end
        //
        if (auLaunchMethod === "OwnWindow" && scoLaunchType === LAUNCH_TYPE_FRAMESET) {
            scoLaunchType = LAUNCH_TYPE_POPUP;
        }
    }
    else if (this.Standard.isLti11()) {
        pathToSco = rscpCfg.get("ltiLaunchTemplate");
    }
    else if (this.Standard.isLti13()) {
        pathToSco = "begin-oidc-flow.html";
    }
    else {
        if (this.Standard.isAICC()) {
            // TODO: test that extRegId is "" instead of null for previews
            isPreview = rscpCfg.get("extRegId") === "";

            if (isPreview) {
                aiccSid = "AICC_SID=" + escape(this.ConstructPreviewAiccSid(activity) + escape(rscpCfg.get("extCfg")));
            }
            else {
                aiccSid = "AICC_SID=" + escape(activity.AiccSessionId);
                isSessionIdIsAGuid = activity.AiccSessionId.length === 36 && activity.AiccSessionId.indexOf("~") < 0;

                //
                // Skip appending the external config for legacy registrations which have an AiccSessionId that actually contains
                // the external config embedded within it.
                //
                if (isSessionIdIsAGuid) {
                    aiccSid += escape(escape(rscpCfg.get("extCfg")));
                }
            }

            aiccParams += aiccSid + "&AICC_URL=" + escape(rscpCfg.get("aiccResultsPage"));
        }

        // if activity url is relative then prepend pathToCourse, unless the course is Tin Can. In the
        // case of Tin Can the generated launch path will either be absolute or already contain the path to course
        // section, so we don't want to add it again.
        // eslint-disable-next-line newline-per-chained-call
        if (this.PathToCourse !== null && this.PathToCourse.length > 0 && activity.GetLaunchPath().toLowerCase().indexOf("http://") !== 0 && activity.GetLaunchPath().toLowerCase().indexOf("https://") !== 0 && ! this.Standard.isTinCan()) {
            pathToSco = this.PathToCourse;

            activityLaunchPath = activity.GetLaunchPath();

            if (this.PathToCourse.lastIndexOf("/") !== (this.PathToCourse.length - 1) && activityLaunchPath.indexOf("/") !== 0) {
                pathToSco += "/";
            }

            pathToSco += activityLaunchPath;
        }
        else {
            pathToSco = activity.GetLaunchPath();
        }

        if (aiccParams !== "") {
            pathToSco = MergeQueryStringParameters(pathToSco, aiccParams);
        }
    }

    if (scoLaunchType === LAUNCH_TYPE_FRAMESET) {
        Control.WriteDetailedLog("Loading Sco In Frameset at: " + pathToSco);

        this.ContentFrame.location = pathToSco;

        Control.Api.InitTrackedTimeStart(activity);
        activity.SetLaunchedThisSession();
    }
    else if (
        scoLaunchType === LAUNCH_TYPE_POPUP
        || scoLaunchType === LAUNCH_TYPE_POPUP_WITHOUT_BROWSER_TOOLBAR
        || scoLaunchType === LAUNCH_TYPE_POPUP_WITH_MENU
        || scoLaunchType === LAUNCH_TYPE_POPUP_AFTER_CLICK
        || scoLaunchType === LAUNCH_TYPE_POPUP_AFTER_CLICK_WITHOUT_BROWSER_TOOLBAR
    ) {
        if (scoLaunchType === LAUNCH_TYPE_POPUP_WITHOUT_BROWSER_TOOLBAR || scoLaunchType === LAUNCH_TYPE_POPUP_AFTER_CLICK_WITHOUT_BROWSER_TOOLBAR) {
            showToolbar = "false";
        }
        else {
            showToolbar = "true";
        }

        if (scoLaunchType === LAUNCH_TYPE_POPUP_WITH_MENU) {
            showMenubar = "yes";
        }
        else {
            showMenubar = "no";
        }

        if (scoLaunchType === LAUNCH_TYPE_POPUP_AFTER_CLICK || scoLaunchType === LAUNCH_TYPE_POPUP_AFTER_CLICK_WITHOUT_BROWSER_TOOLBAR) {
            launchAfterClick = "true";
        }
        else {
            launchAfterClick = "false";
        }

        if (this.WrapScoWindowWithApi === true) {
            launchPath = MergeQueryStringParameters(
                this.PopupLauncherPage.PageHref,
                this.PopupLauncherPage.Parameters,
                "ScoUrl=" + encodeURIComponent(pathToSco),
                "LaunchAfterClick=" + launchAfterClick,
                "WrapApi=true",
                "ShowToolbar=" + showToolbar,
                "ShowMenubar=" + showMenubar
            );
        }
        else {
            launchPath = MergeQueryStringParameters(
                this.PopupLauncherPage.PageHref,
                this.PopupLauncherPage.Parameters,
                "ScoUrl=" + encodeURIComponent(pathToSco),
                "LaunchAfterClick=" + launchAfterClick,
                "ShowToolbar=" + showToolbar,
                "ShowMenubar=" + showMenubar
            );
        }

        this.ContentFrame.location = launchPath;
    }
    else {
        Debug.AssertError("Invalid Sco Launch Type");
    }

    if (typeof IntegrationImplementation.PostScoLoaded === "function") {
        IntegrationImplementation.PostScoLoaded(activity);
    }
}

function ScoLoader_UnloadSco (messageToDisplay) {
    var path = "";

    if (Control.Package.Properties.MakeStudentPrefsGlobalToCourse === true) {
        Control.UpdateGlobalLearnerPrefs();
    }

    if (Control.DeliverFramesetUnloadEventCalled) {
        path = "blank.html";
    }
    else if (messageToDisplay === true) {
        path = MergeQueryStringParameters(this.IntermediatePage.PageHref, this.IntermediatePage.Parameters, "MessageWaiting=true");
    }
    else {
        path = MergeQueryStringParameters(this.IntermediatePage.PageHref, this.IntermediatePage.Parameters);
    }

    if ((this.ScoLaunchType === LAUNCH_TYPE_POPUP || this.ScoLaunchType === LAUNCH_TYPE_POPUP_AFTER_CLICK) && this.ContentFrame.CloseSco) {
        if (Control.DeliverFramesetUnloadEventCalled) {
            if (this.ContentFrame.scoWindow && this.ContentFrame.scoWindow !== null && ! this.ContentFrame.scoWindow.closed) {
                this.ContentFrame.scoWindow.close();
            }
            this.ContentFrame.location = path;
        }
        else {
            Control.WriteDetailedLog("Closing Sco");
            this.ContentFrame.CloseSco();

            if (this.ContentFrame
                && this.ContentFrame.window
                && this.ContentFrame.window.parent
                && this.ContentFrame.window.parent.DispatchDriver
                && this.ContentFrame.window.parent.ExternalRegistrationId
                && this.ContentFrame.window.parent.AICC_API
            ) {
                path = MergeQueryStringParameters(path, "dispatchRegistration=" + this.ContentFrame.window.parent.ExternalRegistrationId);
            }

            Control.WriteDetailedLog("Launching intermediate page from " + path);

            // eslint-disable-next-line no-implied-eval
            window.setTimeout("Control.ScoLoader.ContentFrame.location = '" + path + "'", 250);
        }
    }
    else {
        Control.WriteDetailedLog("UnLoading Sco and launching intermediate page from " + path);
        this.ContentFrame.location = path;
    }

    if (typeof IntegrationImplementation.PostScoUnloaded === "function") {
        IntegrationImplementation.PostScoUnloaded();
    }
}

function ScoLoader_FindContentFrame (wnd) {
    // search all child frames recursively until we find the content frame
    var contentWindow = null,
        i;

    for (i = 0; i < wnd.frames.length; i += 1) {
        if (wnd.frames[i].name === IntegrationImplementation.CONTENT_FRAME_NAME) {
            contentWindow = wnd.frames[i];

            return contentWindow;
        }

        contentWindow = ScoLoader_FindContentFrame(wnd.frames[i]);

        if (contentWindow !== null) {
            return contentWindow;
        }
    }

    return null;
}

function ScoLoader_ConstructPreviewAiccSid (activity) {
    //
    // 2-digit lengths are used so we can parse out these ids without the use of
    // delimeters which could cause encoding problems on the url
    //
    var packageId = rscpCfg.get("registrationToDeliver").Package.Id,
        packageIdLength,
        scormObjectId,
        scormObjectIdLength;

    if (packageId.length < 10) {
        packageIdLength = "0" + packageId.length.toString();
    }
    else {
        packageIdLength = packageId.length.toString();
    }

    scormObjectId = activity.ScormObjectDatabaseId;
    if (scormObjectId.length < 10) {
        scormObjectIdLength = "0" + scormObjectId.length.toString();
    }
    else {
        scormObjectIdLength = scormObjectId.length.toString();
    }

    return "PREVIEW" + packageIdLength + packageId + scormObjectIdLength + scormObjectId;
}
